import { render, staticRenderFns } from "./performance-competency-score-card.vue?vue&type=template&id=0c7233e4"
import script from "./performance-competency-score-card.vue?vue&type=script&lang=js"
export * from "./performance-competency-score-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports